const STATUS_OPTIONS = [
   {
      value: 1,
      label: 'Active',
      id: 1,
      name: 'active',
   },
   {
      value: 2,
      label: 'Inactive',
      id: 2,
      name: 'inactive',
   },
];

export default STATUS_OPTIONS;
